<!-- カード一覧のタイトル表示 -->

<script setup lang="ts">
  import { useDisplay } from "vuetify";
  import MenuIcon, { type ICON_TYPE } from "~/components/Atoms/MenuIcon.vue";

  interface Props {
    icon?: ICON_TYPE;
    title?: string;
    description?: string;
    showAll?: boolean;
    showHashTag?: boolean;
    showBorder?: boolean;
    loading?: boolean;
    showBackButton?: boolean | false;
  }

  interface Emits {
    (event: "clickAll"): void;
  }

  const props = defineProps<Props>();
  const emit = defineEmits<Emits>();

  const clickAll = () => {
    emit("clickAll");
  };

  // タイトルの左にアイコンを表示するかどうか
  const showIcon = computed<boolean>(() => !!props.icon);

  // レスポンシブ対応
  const { name } = useDisplay();
  const isPc = computed<boolean>(() => name.value === "lg");
  const isSp = computed<boolean>(() => name.value === "xs");
</script>

<template>
  <div v-if="title" class="title-area mt-4" :class="showBorder ? 'title-area-border' : ''">
    <v-sheet class="d-flex flex-nowrap align-center" color="transparent">
      <AtomsBackButton v-if="showBackButton && isPc" />
      <template v-if="loading">
        <AtomsLoadingSkeleton class="rounded my-2" :width="180" :height="isSp ? 22 : 32" />
      </template>
      <template v-else>
        <v-sheet v-if="showIcon" class="mr-0 mr-sm-3" color="transparent" :height="isSp ? 22 : 32"
          ><MenuIcon :icon="icon" :width="isSp ? 22 : 32"
        /></v-sheet>
        <p :class="isSp ? 'title-text-sp' : 'title-text'">
          <span v-if="showHashTag" class="text-main-01">#</span>{{ title }}
        </p>
        <v-btn
          v-if="showAll"
          class="show-all-text ml-auto ml-sm-8 px-0 cursor-pointer"
          color="transparent"
          :ripple="false"
          variant="text"
          :height="32"
          @click="clickAll"
        >
          <span class="text-main-01"
            >すべて表示
            <v-icon icon="$mdiChevronRight" size="large" />
          </span>
        </v-btn>
      </template>
    </v-sheet>
    <div v-if="description" class="ml-12">
      <span class="description-text">
        {{ description }}
      </span>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  .title-area {
    padding-bottom: 8px;
  }
  .title-area-border {
    border-bottom: 1px solid rgb(var(--v-theme-monochrome-03));
  }
  .title-text {
    font-size: 20px;
    font-weight: 700;
    line-height: 1.8em;
  }
  .title-text-sp {
    font-size: 14px;
    font-weight: 700;
    line-height: 1.8em;
  }
  .show-all-text {
    font-size: 14px;
    font-weight: 400;
    line-height: 1.8em;
  }
  .description-text {
    font-size: 16px;
    font-weight: 400;
    line-height: 1.8em;
    white-space: break-spaces;
  }
</style>
